import { throttle } from 'lodash';
import Swiper, { Navigation, Autoplay } from 'swiper';

export function indexSlider() {
  const slideIndexPickup = document.querySelector('.js-slideIndexPickup');
  const slideIndexPickupNext = document.querySelector('.js-slideIndexPickup');
  const slideIndexResearch = document.querySelector('.js-slideIndexResearch');
  const slideIndexResearchNext = document.querySelector('.js-slideIndexResearchNext');

  // TOPページのNewsスライダー
  indexSliderCreate(slideIndexPickup, '.js-slideIndexPickup', '.js-slideIndexPickupNext', '.js-slideIndexPickupPrev', slideIndexPickupNext);

  // TOPページの研究活動クローズアップスライダー
  indexSliderCreate(slideIndexResearch, '.js-slideIndexResearch', '.js-slideIndexResearchNext', '.js-slideIndexResearchPrev', slideIndexResearchNext);
}

// slideContainerにはswiperの親js-〇〇、nextは次の矢印、prevは前の矢印、navは
function indexSliderCreate(slideContQuery, slideCont, slideNextElement, slidePrevElement, nav) {
  if (slideContQuery) {
    const slideContainer = slideContQuery;
    const slides = slideContainer.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    const navControl = nav.closest('.js-slideNavControl');

    function updateSwiperSettings() {
      const isSmallScreen = window.innerWidth < 768;

      // 動的設定
      let loopSetting = isSmallScreen || slideCount >= 4;
      let navDisplay = isSmallScreen || slideCount >= 4;

      const swiperOptions = {
        modules: [Navigation, Autoplay],
        slidesPerView: 'auto',
        spaceBetween: isSmallScreen ? 20 : 34, // 768px未満なら20、以上なら34
        loop: loopSetting,
        navigation: {
          nextEl: slideNextElement,
          prevEl: slidePrevElement,
        },
      };

      // ナビゲーション要素の表示/非表示を切り替え
      if (navControl) {
        navControl.style.display = navDisplay ? 'flex' : 'none';
      }

      return swiperOptions;
    }

    let swiperOptions = updateSwiperSettings();
    let slideIndexPickup = new Swiper(slideCont, swiperOptions);

    // ウィンドウリサイズ時の処理
    window.addEventListener(
      'resize',
      _.throttle(
        () => {
          const newOptions = updateSwiperSettings();
          const wasLooping = slideIndexPickup.params.loop;
          const shouldLoop = newOptions.loop;

          // ループ状態またはspaceBetweenが変更される場合
          if (wasLooping !== shouldLoop || slideIndexPickup.params.spaceBetween !== newOptions.spaceBetween) {
            slideIndexPickup.destroy(true, true); // Swiperを完全に破棄
            slideIndexPickup = new Swiper(slideCont, newOptions); // 新しいインスタンスを作成
          } else {
            // 変更がない場合は通常の更新
            slideIndexPickup.update();
          }

          if (navControl) {
            navControl.style.display = shouldLoop ? 'flex' : 'none';
          }
        },
        100,
        { trailing: true, leading: true }
      )
    );
  }
}
